import React from 'react';
import Async from 'react-select/async';
import type { SelectOption } from '../Forms/types';

interface FormAsyncSelectProps {
  form: any;
  name: string;
  label?: string;
  placeholder?: string;
  loadOptions: (inputValue: string) => Promise<SelectOption[]>;
  defaultOptions?: SelectOption[] | boolean;
  isMulti?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  cacheOptions?: boolean;
  noOptionsMessage?: (obj: { inputValue: string }) => string;
  loadingMessage?: () => string;
  customComponents?: any;
  isOptionDisabled?: (option: SelectOption) => boolean;
}

export const FormAsyncSelect: React.FC<FormAsyncSelectProps> = ({
  form,
  name,
  label,
  placeholder,
  loadOptions,
  defaultOptions,
  isMulti = false,
  required = false,
  disabled = false,
  className = '',
  isClearable = true,
  isSearchable = true,
  cacheOptions = true,
  noOptionsMessage,
  loadingMessage,
  customComponents,
  isOptionDisabled,
}) => {
  return (
    <form.Field
      name={name}
      children={(field: any) => {
        const hasError = field.state.meta.errors?.length > 0;
        const errorMessage = field.state.meta.errors?.[0];

        return (
          <div className={`${hasError ? 'form-element error' : 'form-element'} ${className}`}>
            {label && (
              <label htmlFor={name}>
                {`${label}${required ? '*' : ''}`}
              </label>
            )}
            <Async
              className="react-select-container"
              classNamePrefix="react-select"
              loadOptions={loadOptions}
              defaultOptions={defaultOptions}
              value={field.state.value}
              onChange={(value) => field.handleChange(value)}
              onBlur={field.handleBlur}
              placeholder={placeholder}
              isMulti={isMulti}
              isDisabled={disabled}
              isClearable={isClearable}
              isSearchable={isSearchable}
              cacheOptions={cacheOptions}
              name={name}
              noOptionsMessage={noOptionsMessage}
              loadingMessage={loadingMessage}
              components={customComponents}
              isOptionDisabled={isOptionDisabled}
            />
            {hasError && (
              <div className="error-message">{errorMessage}</div>
            )}
          </div>
        );
      }}
    />
  );
};